import React from 'react';
import { Refrigerator, Shuffle, BookOpen } from 'lucide-react';

type Props = {
  onRandomRecipe: () => void;
  onIngredientSearch: () => void;
  onViewAllRecipes: () => void;
};

export default function SearchButtons({ onRandomRecipe, onIngredientSearch, onViewAllRecipes }: Props) {
  return (
    <div className="space-y-3 mt-4">
      <div className="flex gap-4">
        <button
          onClick={onIngredientSearch}
          className="flex-1 flex items-center justify-center gap-2 bg-[#31B057] text-white py-3 px-4 rounded-lg hover:bg-[#2a9b4d] transition-colors font-semibold"
        >
          <Refrigerator size={20} />
          <span> frigo واش كاين في </span>
        </button>
        
        <button
          onClick={onRandomRecipe}
          className="flex-1 flex items-center justify-center gap-2 bg-orange-500 text-white py-3 px-4 rounded-lg hover:bg-orange-600 transition-colors font-semibold"
        >
          <Shuffle size={20} />
          <span>وش نطيبو ليوم ؟</span>
        </button>
      </div>
      
      <button
        onClick={onViewAllRecipes}
        className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-lg transition-colors font-semibold text-gray-700 hover:bg-gray-200"
        style={{ backgroundColor: '#F1F1F1' }}
      >
        <BookOpen size={20} />
        <span>Toutes les recettes كل الوصفات</span>
      </button>
    </div>
  );
}